export const calendarStyles = `
.rdv-calendar-shell {
  background: linear-gradient(180deg, color-mix(in srgb, var(--rdv-accent) 4%, transparent), color-mix(in srgb, var(--rdv-accent) 1%, transparent));
  border: 1px solid var(--rdv-border);
  border-radius: calc(var(--rdv-radius) + 4px);
  padding: 12px;
}

.rdv-calendar-shell-loading {
  overflow: hidden;
}

.rdv-calendar-skeleton {
  animation: rdv-calendar-pulse 1.2s ease-in-out infinite;
  background: linear-gradient(90deg, color-mix(in srgb, var(--rdv-accent) 6%, transparent), color-mix(in srgb, var(--rdv-accent) 14%, transparent), color-mix(in srgb, var(--rdv-accent) 6%, transparent));
  background-size: 200% 100%;
  border-radius: 12px;
  display: block;
}

.rdv-calendar-skeleton-head {
  height: 40px;
  margin-bottom: 14px;
}

.rdv-calendar-skeleton-grid {
  display: grid;
  gap: 6px;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.rdv-calendar-skeleton-day {
  height: 46px;
}

.rdv-calendar-input {
  height: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  width: 0;
}

.rdv-calendar-hint {
  color: var(--rdv-muted);
  font-size: 0.88rem;
  margin: 12px 0 0;
}

.rdv-root .flatpickr-calendar.inline {
  background: transparent;
  border: 0;
  box-shadow: none;
  margin: 0;
  width: 100%;
}

.rdv-root .flatpickr-months {
  /* La CSS de flatpickr n'est pas chargée dans le shadow DOM : sans flex,
     les flèches ‹ › s'empilent au-dessus et au-dessous du mois. */
  display: flex;
  align-items: center;
  background: transparent;
  gap: 8px;
  margin-bottom: 12px;
}

.rdv-root .flatpickr-month {
  flex: 1;
  min-width: 0;
  color: var(--rdv-text);
  fill: var(--rdv-text);
  height: 40px;
}

.rdv-root .flatpickr-current-month {
  align-items: center;
  display: flex;
  font-size: 1rem;
  font-weight: 800;
  gap: 8px;
  height: 40px;
  justify-content: center;
  left: 0;
  padding: 0 40px;
}

.rdv-root .flatpickr-current-month .flatpickr-monthDropdown-months,
.rdv-root .flatpickr-current-month input.cur-year {
  color: var(--rdv-text);
  font-size: 1rem;
  font-weight: 800;
}

.rdv-root .flatpickr-current-month .numInputWrapper,
.rdv-root .flatpickr-current-month .flatpickr-monthDropdown-months {
  pointer-events: none;
}

/* L'année n'est pas un sélecteur : le champ numérique de flatpickr est
   masqué (calendarPicker.showYearAsText) et remplacé par un texte simple. */
.rdv-root .flatpickr-current-month .numInputWrapper,
.rdv-root .flatpickr-current-month .numInputWrapper[hidden] {
  display: none !important;
}

.rdv-root .flatpickr-current-month .rdv-cur-year {
  color: var(--rdv-text);
  font-size: 1rem;
  font-weight: 800;
}

/* Flèches de mois : invisibles quand on ne peut pas aller plus loin
   (flatpickr pose flatpickr-disabled selon minDate/maxDate). visibility,
   et non display, pour garder le mois centré. */
.rdv-root .flatpickr-prev-month.flatpickr-disabled,
.rdv-root .flatpickr-next-month.flatpickr-disabled {
  pointer-events: none;
  visibility: hidden;
}

.rdv-root .flatpickr-prev-month,
.rdv-root .flatpickr-next-month {
  align-items: center;
  background: var(--rdv-surface);
  border: 1px solid var(--rdv-border);
  border-radius: 999px;
  color: var(--rdv-text);
  display: inline-flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  top: 2px;
  width: 36px;
}

.rdv-root .flatpickr-prev-month:hover,
.rdv-root .flatpickr-next-month:hover {
  background: var(--rdv-accent-soft);
  border-color: var(--rdv-accent);
}

.rdv-root .flatpickr-weekdays {
  background: transparent;
  margin-bottom: 6px;
}

.rdv-root .flatpickr-weekdaycontainer {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  width: 100%;
}

.rdv-root span.flatpickr-weekday {
  align-items: center;
  color: var(--rdv-muted);
  display: flex;
  font-size: 0.78rem;
  font-weight: 800;
  justify-content: center;
  margin: 0;
  width: 100%;
}

.rdv-root .flatpickr-days,
.rdv-root .dayContainer {
  max-width: none;
  min-width: 100%;
  width: 100%;
}

.rdv-root .dayContainer {
  display: grid;
  gap: 6px;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.rdv-root .flatpickr-day {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 14px;
  color: var(--rdv-text);
  display: inline-flex;
  height: 46px;
  justify-content: center;
  line-height: 1;
  margin: 0;
  max-width: none;
  position: relative;
  width: 100%;
}

.rdv-root .flatpickr-day:hover {
  background: color-mix(in srgb, var(--rdv-accent) 8%, transparent);
  border-color: color-mix(in srgb, var(--rdv-accent) 18%, transparent);
}

.rdv-root .flatpickr-day.today {
  border-color: color-mix(in srgb, var(--rdv-accent) 25%, transparent);
}

.rdv-root .flatpickr-day.flatpickr-disabled,
.rdv-root .flatpickr-day.flatpickr-disabled:hover,
.rdv-root .flatpickr-day.prevMonthDay,
.rdv-root .flatpickr-day.nextMonthDay {
  background: transparent;
  border-color: transparent;
  color: #c0cad7;
}

.rdv-root .flatpickr-day.rdv-day-unavailable {
  background: rgba(23, 32, 51, 0.03);
  border-color: rgba(217, 224, 234, 0.9);
  color: #98a2b3;
}

.rdv-root .flatpickr-day.rdv-day-unavailable::after {
  background: currentColor;
  border-radius: 999px;
  bottom: 6px;
  content: "";
  display: block;
  height: 4px;
  left: 50%;
  opacity: 0.6;
  position: absolute;
  transform: translateX(-50%);
  width: 4px;
}

.rdv-root .flatpickr-day.rdv-day-has-slots {
  background: var(--rdv-accent-soft);
  border-color: transparent;
  color: var(--rdv-accent-ink);
  font-weight: 800;
}

.rdv-root .flatpickr-day.rdv-day-has-slots:hover,
.rdv-root .flatpickr-day.rdv-day-has-slots:focus {
  background: color-mix(in srgb, var(--rdv-accent) 16%, transparent);
  border-color: color-mix(in srgb, var(--rdv-accent) 24%, transparent);
}

.rdv-root .flatpickr-day.selected,
.rdv-root .flatpickr-day.startRange,
.rdv-root .flatpickr-day.endRange,
.rdv-root .flatpickr-day.selected.rdv-day-has-slots {
  background: var(--rdv-accent);
  border-color: var(--rdv-accent);
  color: #ffffff;
}

.rdv-root .flatpickr-day:focus-visible {
  border-color: var(--rdv-focus);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--rdv-accent) 22%, transparent);
  outline: 2px solid transparent;
}

/* Compteur de créneaux centré SOUS le numéro du jour (en coin, il masquait le
   second chiffre dès que les cellules rétrécissent). */
.rdv-root .flatpickr-day.rdv-day-counted {
  padding-bottom: 12px;
}

.rdv-root .flatpickr-day .rdv-day-marker {
  align-items: center;
  background: #ffffff;
  border-radius: 999px;
  bottom: 4px;
  color: var(--rdv-accent-ink);
  display: inline-flex;
  font-size: 0.58rem;
  font-weight: 800;
  height: 13px;
  justify-content: center;
  left: 50%;
  min-width: 13px;
  padding: 0 3px;
  position: absolute;
  transform: translateX(-50%);
}

.rdv-root .flatpickr-day.selected .rdv-day-marker {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}

@media (max-width: 520px) {
  .rdv-root .dayContainer {
    gap: 4px;
  }

  .rdv-root .flatpickr-day {
    height: 42px;
  }

  .rdv-calendar-skeleton-day {
    height: 42px;
  }
}

/* Même règle selon la largeur réellement disponible (widget intégré dans une
   colonne étroite d'une page large) ; le compteur passe sous le numéro. */
@container rdv (max-width: 520px) {
  .rdv-root .dayContainer {
    gap: 4px;
  }

  .rdv-root .flatpickr-day {
    height: 42px;
  }

  .rdv-calendar-skeleton-day {
    height: 42px;
  }

  .rdv-root .flatpickr-day.rdv-day-counted {
    padding-bottom: 12px;
  }

  .rdv-root .flatpickr-day .rdv-day-marker {
    bottom: 3px;
    font-size: 0.56rem;
    height: 13px;
    left: 50%;
    min-width: 13px;
    padding: 0 3px;
    right: auto;
    transform: translateX(-50%);
  }
}

@keyframes rdv-calendar-pulse {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
`;